import React from 'react';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';

export const Empty = ({ text }) => (
    <div className={`${style.emptyContainer} cms-games-empty`}>
        <h2 className={style.head}>{text}</h2>
        <Icon type="filterEmpty" className={style.icon} />
    </div>
);

export default Empty;
